<template>
  <div class="main-container" :disabled="!ifTeamleaderAnchorPermission">
    <!-- Author: Bhushan
      Date: 27/02/2021
      Description: IT Proof Approval component-->
   <!--  <breadcrumb :list="breadcrumbList" />  -->
  
    <div class="margintop-16" />
    <button v-if="this.role === 'AUDITOR'" class="act-btn" @click="backtomainscreen()">Back</button>
    <tl-header type="h1">Approve/Reject IT Proofs</tl-header>
    <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
      You have only view permission.
    </div>
    <div class=" lineheight">
      <div>
        <div class="float-right">
          <!-- <span style="cursor:pointer" @click="bulkuploadIncomeTax">
            <img class="search-icon-filter" src="@/assets/logout-copy-2.svg" style="width: 30px;height: 34px;" alt /> <span
              class="filter-text">Bulk File Upload </span>
          </span>-->
          <span v-if="this.role === 'ADMIN'" style="cursor:pointer" @click="bulkuploadIncomeTax">
            <img class="search-icon-filter" src="@/assets/logout-copy-2.svg" style="width: 30px;height: 34px;" alt /> <span
              class="filter-text">Bulk File Upload </span>
          </span>
          <span v-if="this.role === 'ADMIN'" style="cursor:pointer; margin-left: 20px;" @click="downloadItProofSubmittedDetails">
            <img class="search-icon-filter" src="@/assets/download.svg"  style="width: 30px;height: 34px;" alt /> <span class="filter-text">Download IT Proof Details</span>
           </span> 
           <span style="cursor:pointer; margin-left: 20px;" @click="downloadItSubmissionDetails">
            <img class="search-icon-filter" src="@/assets/download.svg"  style="width: 30px;height: 34px;" alt /> <span class="filter-text">Download IT Submission Status</span>
          </span>
        </div>
      </div>
      <!-- <div>
        <div class="float-right">
            <tl-checkbox
                label='Show All Employee Status'
                name="employee"
                id="employee"
                v-model="showAllEmployee"
                @change="(val) =>{
                  if(val){
                    fetchemp()
                  }else{
                    fetchempValidate()
                  }
                } "
              />
        </div>
      </div>  -->
     
    <!-- Search box and upload button add here -->
    <div class="selectdiv my-3">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-6 pl-0">
                <div class="search-container">
                    <tl-search @change="filterData($event)" @blur="filterOnblur($event)" :placeholder="'Search Employee Name'" />
                </div>
            </div>
            <div class="col-6">
                <!-- <a class="anchor-underline-none show-filter-block" href="#">
                    <img class="search-icon-filter" src="@/assets/filter.png" alt="" />
                    <span class="filter-text">Show Filter</span>
                </a> -->
                
            </div>    
          </div>  
          
        </div>
        <div class="col-4">
           <div>
        <div class="float-right mt-3">
            <tl-radio
                label='Audit Pending'
                name="auditPending"
                id="auditPending"
               
                value="pending"
                v-model="showAllEmployee"
                v-on:change="fetchempValidate"
              />
            
               <tl-radio
                label='Audit Approved'
                name="auditApproved"
                id="auditApproved"
                v-model="showAllEmployee"
                value="approved"
               
                 v-on:change="fetchempValidateApproved"
              />
              <tl-radio
                label='Show All Employee Status'
                name="employee"
                id="employee"
                v-model="showAllEmployee"
                value="all"
               
                 v-on:change="fetchemp"
              />
        </div>
      </div> 
          <!-- <tl-select
              name="Approval"
              labelText="approval"
              class="customwidth"
              options="All"
              v-validate="{required: true}"
              :classname="errors.has('State')"
              :errormsg="errors.first('State')"
            ></tl-select> -->
        </div>
      </div>
    </div>
    <!-- End Code -->

      <div>{{employeeData.length}}&nbsp;/&nbsp;{{employeeData.length}}</div>
      <div class="table-div" ref="table_div" @scroll="onScroll()">
        <data-table
          :columns="employeeTableColumns"
          :tableData="employeeData"
          :showinrow="true"
          :with-form="true"
          :showPaging = "true"
          :showhistory="false"
          :showdelete="false"
          :showedit="false"
        >
        <template v-if="this.role === 'AUDITOR' && auditValidated !=='Not Applicable'" v-slot:rowcontent="slotprops">
          <div v-if="slotprops.value.column.key=='actionforAuditor'">
            <button :disabled="slotprops.value.record.auditValidated == 'Not Applicable'" class="act-btn" @click="navigateToIncomeTax(slotprops)">Act</button>
          </div>
          </template>
   
      </data-table>
      </div>
      </div>
      <pop-up-window
        v-if="showIncomeTaxBulkPopup"
        @back="showIncomeTaxBulkPopup = !showIncomeTaxBulkPopup"
        header="Bulk Upload Income Tax Approval Details">
          <template v-slot:content>
            <income-tax-approve-bulk-popup
            @back="showIncomeTaxBulkPopup = !showIncomeTaxBulkPopup"
            @hidepopup="popupHide">
            </income-tax-approve-bulk-popup>
         </template>

      </pop-up-window>
    </div>
</template>


<script>
import { mapGetters, mapActions, mapState } from "vuex";
import incomeTaxApproveBulkPopup from "./incometaxApproveBulk.vue";
export default {
  props: {},
  components: {
    incomeTaxApproveBulkPopup
  },
  data() {
    return {
      showIncomeTaxBulkPopup: false,
      currentObj: {},
      popupType: "ConfirmDelete",
      showConfirmDelete: false,
      toast: false,
      showAllEmployee: false,
      showAuditPending: true,
      showAuditApproved:false,
      errmsg: "",
      page: 1,
      totalEmployees: 0,
      locationList: [],
      designationList: [],
      employeeData: [],
      sectionData:[
    {
        id: "2e790873-9857-454c-be79-1708ae5577f0",
        createdBy: null,
        updatedBy: null,
        customAttr: null,
        employee_id: "6dabf9cb-f865-4999-97f8-2f47333c37a7",
        financial_year: "2025",
        investment_component_type_id: "41815fc3-bb5b-4051-8520-0108a4a4f658",
        planned: 0,
        actual: 0,
        approved: 0,
        audited: false,
        remarks: null,
        audit_remarks: null,
        it_plan_id: "abdda8b3-088a-4c37-8603-6224088a95c5",
        regime_type: "oldregime",
        file_location: "",
        status: "not_approved",
        legal_entity_id: "08f3289f-299d-4f8a-a9c1-574b65d10743",
       
        file_name: null,
        
        InvestmentComponentType: {
            id: "41815fc3-bb5b-4051-8520-0108a4a4f658",
           
            name: "Medical Insurance Premium Parents",
          
        }
    },
    {
        id: "a81d07c5-3878-4fd9-a356-c7ee1d455995",
       
        employee_id: "6dabf9cb-f865-4999-97f8-2f47333c37a7",
       
        planned: 0,
        actual: 0,
        approved: 0,
          status: "not_approved",
        file_location: "",
       
        file_name: null,
       
        InvestmentComponentType: {
            id: "0c884b5e-e827-4c07-b640-87d3667da0f0",
           
            name: "Medical Insurance Premium Parents Sr. Citizen",
          
        }
    },
    {
        id: "5ac98191-b049-48a9-a743-60f194cbb511",
       
      
        planned: 0,
        actual: 0,
        approved: 0,
       
        file_location: "",
        status: "not_approved",
        
        file_name: null,
       
        InvestmentComponentType: {
            id: "a03d7843-c02c-4368-bc3a-a87014efa166",
           
            name: "Medical Insurance Premium Self & Family",
         
        }
    },
    {
        id: "eea486dc-d167-472f-8ef2-e6bcdfb45850",
       
        planned: 0,
        actual: 0,
        approved: 0,
       
        file_location: "",
         status: "not_approved",
        file_name: null,
      
        InvestmentComponentType: {
            id: "e7ad2a1b-4a1b-423a-8cc7-b1ca6f0ee395",
           
            name: "Medical Insurance Premium Self & Family Sr. Citizen",
          
        }
    },
    {
        id: "92609f1d-cfd6-4a9d-ab1c-044c25181346",
        planned: 0,
        actual: 0,
        approved: 0,
       
        file_location: "",
         status: "not_approved",
        file_name: null,
       
        InvestmentComponentType: {
            id: "c6098b21-e648-444e-aec5-422365b20192",
           
            name: "Preventive Health Check Up Upto 5000 Part of Above",
          
        }
    }
      ],
    auditTableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Declared Amount",
          key: "declaredAmount"
        },
        {
          label: "Submitted Amount",
          key: "submittedAmount"
        },
        {
          label: "Verfied Amount",
          key: "verfiedAmount"
        },
        {
          label: "Proof",
          key: "proof"
        },
        {
          label: "Status",
          key: "status"
        },
        {
           label: "Remarks",
          key: "remarks"
        },
        {
           label: "Action",
          key: "action"
        },

      ],
      employeeTableColumns: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Employee Name",
          key: "name"
        },
        // {
        //   label: "Total Investment",
        //   key: "designation"
        // },
        // {
        //   label: "Approved Amount",
        //   key: "approved_amount"
        // },
        // {
        //   label: "Request Date",
        //   key: "request_date"
        // },
        {
          label: "ItProof Submitted",
          key: "itProofStatus"
        },
        {
          label: "ItProof Submitted Date",
          key: "itProofDate"
        },
        {
          label: "Audit status",
          key: "auditValidated"
        },
        {
          label: "Action",
          key: "actionforAuditor"
        },
      ],
      tempArrayList: [],
      approveAndRejectItProofValue: false,
      itProofApprovalValue: false,
      role: ""
    };
  },
  activated() {
    this.page = 1;
    this.toast = false;
    this.employeeData = [];
    this.getLocations();
    this.showAllEmployee=false
    //this.getDesignation();
    // this.fetchemp();
    this.fetchempValidate();
    this.getOrgLeIdList();
  },
  // PL_2989
  mounted() {
    this.le_id()
    console.log("im loading....")
    this.toast = false;
    this.employeeData = []; 
    this.page = 1
    this.showAllEmployee="pending"
    this.fetchempValidate();
     this.getLocations();
     this.getOrgLeIdList();
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      name: state => state.auth.name,
      email: state => state.auth.email,
      globalData: state => state.globalapi.globalData,
      payrollYear: state => state.payroll.runpayroll.payrollYear,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    le_id() {
      console.log(this.getleid(this.$route.params.entity_index),"le")
      if (this.$route.params.entity_index)
     
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
       
    },
    // ifAuditorPermission() {
    //   if(this.approveAndRejectItProofValue) {
    //     return true;
    //   }
    // },
    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" || this.role === "AUDITOR"  || this.role === 'ADMIN'
      ) {
        if (this.itProofApprovalValue || this.approveAndRejectItProofValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true;
      // }
    },
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/employees/fetchAll",
      fetchLocations: "onboard/locations/fetchAll",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
      act_download_it_proof_submitted_template: "dashboard/payroll/incometax/downloadItProofDetails",
      act_download_it_submission_template: "dashboard/payroll/incometax/downloadItSubmissionDetails",
    }),

    bulkuploadIncomeTax() {
        this.showIncomeTaxBulkPopup = true;
    },
     popupHide() {
      this.showIncomeTaxBulkPopup = false;
    },
    backtomainscreen(){      
      this.$router.push({ path: "/orgSummary" });
    },
    async downloadItSubmissionDetails(){
      try {
      let payload = {
        le_id: this.le_id,
        financial_year: this.calculateFinancialYear()
      }
      
       let res = await this.act_download_it_submission_template(payload);
     } catch (error) {
    window.alert("Please try again after some time")
       
     }
    },
    calculateFinancialYear() {
      
      if (this.payrollMonth === 'January' || this.payrollMonth === 'February' || this.payrollMonth === 'March') {
          return this.payrollYear - 1;
      }
      else{
        return this.payrollYear;
      }
      },
    /* server call to get locations for current Legal Entity */
    async getLocations() {
      try {
        let res = await this.fetchLocations(this.le_id);
        if (res.data.status) {
          this.locationList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
     async downloadItProofSubmittedDetails(){
      try {
      let payload = {
        le_id: this.le_id,
        financial_year: this.calculateFinancialYear()
      }
       let res = await this.act_download_it_proof_submitted_template(payload);
     } catch (error) {
    window.alert("Please try again after some time")
       
     }
    },
    /* server call to get Employees for current Legal Entity */
    async fetchemp() {
      
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page,financial_year:2025});
        console.log("IT PRoof", res);
        if (res.data.status) {
          
          this.showAllEmployee="all"
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              itProofDate:element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.it_proof_flag?new Date(element.updated_at).toLocaleDateString("en-GB").replace(/\//g, '-'):'Not Applicable',
              itProofStatus:element && element.status,
              auditValidated:element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.is_audit_validated ?"Approved":element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.it_proof_flag?"Pending":"Not Applicable",
              // auditValidated:element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.it_proof_flag=='Pending'?'Not Applicable':(element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.is_audit_validated) ?"Approved":"Pending",
              location: element.EmployeeOfficial
                ? this.getLocationName(element)
                : "",
            });
          });
          // this.employeeData.push(...empList);
          this.employeeData = [...empList]; 
          console.log("emp data",this.employeeData)
          this.tempArrayList = [...empList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
 async fetchempValidate() {
        
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page,financial_year:2025 });
        console.log("IT PRoof111", res);
        if (res.data.status) {
         
          this.showAllEmployee="pending"
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              itProofDate:new Date(element.updated_at).toLocaleDateString("en-GB").replace(/\//g, '-'),                                                                                                                   
              itProofStatus:element && element.status,
              auditValidated:element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.is_audit_validated ?"Approved":"Pending",

              location: element.EmployeeOfficial
                ? this.getLocationName(element)
                : "",
            });
          });
          // this.employeeData.push(...empList);
         let data= empList.filter((item) => item.itProofStatus == "SUBMITTED" && item.auditValidated == "Pending")
            console.log(data,"hiiii")
          this.employeeData = [...data]; 
          console.log("emp data",this.employeeData)
          this.tempArrayList = [...empList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
     async fetchempValidateApproved() {
         
      try {
        let res = await this.act_fetch({ le_id: this.le_id, page: this.page ,financial_year:2025});
        console.log("IT PRoof approved", res);
        if (res.data.status) {
          
          this.showAllEmployee="approved"
          let empList = [];
          this.totalEmployees = res.data.payload.totalEmpCount;
          res.data.payload.data.forEach(element => {
            empList.push({
              id: element.id,
              name:
                element.first_name +
                " " +
                (element.last_name ? element.last_name : ""),
              code: element.code,
              itProofDate:new Date(element.updated_at).toLocaleDateString("en-GB").replace(/\//g, '-'),                                                                                                              
              itProofStatus:element && element.status,
              auditValidated:element.EmployeeInvestmentPlanHead &&element.EmployeeInvestmentPlanHead.is_audit_validated ?"Approved":"Pending",

              location: element.EmployeeOfficial
                ? this.getLocationName(element)
                : "",
            });
          });
          // this.employeeData.push(...empList);
         let data= empList.filter((item) => item.auditValidated == "Approved")
            console.log(data,"hiiii")
          this.employeeData = [...data]; 
          console.log("emp data",this.employeeData)
          this.tempArrayList = [...empList];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /* function to search in local by name */
    filterData(val) {
      try {
        let tempArray = [];
        this.tempArrayList.forEach(element => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
          if (element.code) {
            if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.employeeData = tempArray;
        } else {
          this.employeeData = [...this.tempArrayList];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    filterOnblur(val){
      try {
        let tempArray = [];
        this.tempArrayList.forEach(element => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
          if (element.code) {
            if (element.code.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.employeeData = tempArray;
        } else {
          this.employeeData = [...this.tempArrayList];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    
    /* function to get Employees on scroll */
    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchemp();
      }
    },
    /* function to get location name based on location id */
    getLocationName(element) {
      let location = this.locationList.find(item => {
        if (!element.EmployeeOfficial) return false;
        else return item.id == element.EmployeeOfficial.based_location_id;
      });
      return location ? location.name : "";
    },
      /* function to income tax dashboard */
    navigateToIncomeTax(rec){
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxaudit`,
        query: { id: rec.value.record.id }
      });
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.approveAndRejectItProofValue = data.data.user.permissions.approve_and_reject_it_proof ? true : false;
      this.itProofApprovalValue = data.data.user.permissions.it_proof_approval ? true : false;
      //console.log("PL-3406",data);
     }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

.act-btn {
  background-color: #cccccc ;
  color: rgb(9, 9, 9);
  border: none ;
  padding: 5px 10px ;
  border-radius: 5px ;
  cursor: pointer ;
}

.act-btn:hover {
  background-color: #34c0be;
  color: #f2f4f6;

}
.customwidth {
  width: 200px;
  //margin-right: 32px;
  float: right;
}
.table-div {
  min-height: 350px;
  // max-height: 500px;
  margin-bottom: 175px;
  overflow: auto;
}
.add-btn-small {
  height: auto;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.employee-info {
  height: 150px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  padding: 20px 15px 20px 25px;
  position: relative;
  &:nth-child(n) {
    margin-right: 20px;
  }
  .btn-primary-small {
    background-color: white;
    color: $color-primary;
    border-radius: 4px;
    border: 1px solid $color-primary;
    height: 25px;
    padding: 0px 20px;
    font-size: $font-size-small;
    width: auto;
  }

  .header-text {
    font-size: 24px;
    font-weight: bold;
    color: $color-secondary;
  }
  .sub-text {
    font-size: 20px;
    color: $color-primary;
    margin-top: 20px;
  }
  .btn-upload {
    position: absolute;
    bottom: 20px;
    right: 15px;
  }
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
  span {
    color: #858585;
    font-size: 18px;
  }
}
.action-container {
  margin-left: auto;
  display: flex;
  justify-content: flex-end;
}
.noData {
  text-align: center;
  padding: 10% 0 10% 0;
}
.noData span {
  font-size: 18px;
  color: #858585;
}
.lineheight{
  height: 1px;
}


.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
}
a.anchor-underline-none {
  text-decoration: none;
}
.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 30px;
  height: 30px;
  // margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}
span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
}

.filter-width {
  width: 390px;
}

.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
}

.download-block {
  position: absolute;
  width: 220px;
  transform: translate(-76%, -24%);
}

.grid-list-block {
  transform: translate(0%, -12%);
}

a.anchor-underline-none {
  text-decoration: none;
}


.line {
  width: 1px;
  height: 18px;
  margin: 0px 13px 0px 1px; //41px 13px 32px 15px;
  opacity: 0.16;
  border: solid 1px #30b6bc;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
